<script setup>
import {computed, watch} from "vue";
import {useStore} from "vuex";
import useDates from "@/composables/useDates";
import HintSquare from "@/components/global-themed/HintSquare.vue";
import CustomMultiselect from "@/components/global-themed/CustomMultiselect.vue";
import RefreshCompetitorButton from "@/components/competition/partials/RefreshCompetitorButton.vue";

const dates = useDates();

const store = useStore();

const competitors = computed(() => store.getters['competitionV2/competitors'].filter((competitor) => !competitor.isWebsiteAsCompetitor));

const selectedCompetitor = computed(() => store.getters['competitionV2/competitor']);

const selectedCompetitorId = computed({
  get: () => selectedCompetitor.value?.id,
  set: (value) => {
    if (!value) {
      store.dispatch('competitionV2/setCompetitor', undefined);
      return;
    }
    const newSelectedCompetitor = competitors.value.find(competitor => competitor.id === value);
    store.dispatch('competitionV2/setCompetitor', newSelectedCompetitor);
  }
});

const competitorOptions = computed(() => {
  return competitors.value.map(competitor => ({
    value: competitor.id,
    label: competitor.simpleUrl
  }));
});

watch(selectedCompetitor, () => {
  if (selectedCompetitor.value === undefined) {
    store.dispatch('competitionV2/setCompetitorDetails', undefined);
    return;
  }
  store.dispatch('competitionV2/fetchCompetitorDetails');
})

</script>

<template>
  <div class="tw-flex tw-divide-x">
    <div class="tw-w-full tw-flex-grow-1 tw-pr-8">
      <label
        for="competitor"
        class="tw-text-grey tw-mb-4"
      >
        Select Competitor
      </label>
      <CustomMultiselect
        id="competitor"
        v-model="selectedCompetitorId"
        class="tw-relative"
        :options="competitorOptions"
        placeholder="Select Competitor"
        mode="single"
        :close-on-select="true"
        :can-deselect="true"
        :searchable="true"
      >
        <template #icon>
          <svg-vue
            icon="icons/graph-search"
            class="tw-w-7 tw-h-7 tw-text-grey"
          />
        </template>
      </CustomMultiselect>
    </div>

    <div
      v-if="selectedCompetitor"
      class="tw-pl-8 tw-flex tw-flex-col"
    >
      <span class="tw-text-grey tw-mb-auto">Last Audit</span>
      <div class="tw-flex tw-items-center tw-gap-4">
        <span class="tw-whitespace-nowrap tw-text-lg tw-text-grey-dark">
          {{ dates.formattedDate(selectedCompetitor.lastAuditedAt, 'Do MMMM YYYY') }}
        </span>

        <HintSquare hint="Date that the audit for this domain was last completed." />

        <RefreshCompetitorButton />
      </div>
    </div>
  </div>
</template>
